export default __webpack_public_path__ + "static/media/janela-componente.5b95442c.svg";